import { Box } from '@ironhack/design-system2/components/box';
import { Card } from '@ironhack/design-system2/components/card';
import { Flex } from '@ironhack/design-system2/components/flex';
import { Grid, GridItem } from '@ironhack/design-system2/components/grid';
import { HexagonBadge } from '@ironhack/design-system2/icons/hexagon-badge';
import { Text } from '@ironhack/design-system2/components/text';

import { CmsImage } from '@/app/components/server/cms-image';
import { type DatoImage } from '@/lib/datocms';

export type StudentKnowledge = {
  title: string;
  courses: Array<{
    text: string;
    hexagonColor: string;
  }>;
  technologies: Array<{
    text: string;
    image: DatoImage;
  }>;
};

type Props = { data: StudentKnowledge };

export const StudentKnowledge = (props: Props) => {
  const { data } = props;
  const { title, courses, technologies } = data;

  return (
    <Box as="section" overflowX={['auto', null, 'unset']}>
      <Text mb="3" textStyle="lBold">
        {title}
      </Text>

      <Grid gap="2" templateColumns="repeat(4, 1fr)">
        {courses.map((course) => (
          <GridItem colSpan={1} key={course.text}>
            <Card
              boxShadow="0px 0px 4px rgba(0, 0, 0, 0.24)"
              direction="row"
              w="full"
            >
              <Flex alignItems="center" gap="2" p="2">
                <HexagonBadge
                  color={`url(#${course.hexagonColor})`}
                  fill={`url(#${course.hexagonColor})`}
                />
                <Text textStyle="lBold" whiteSpace="nowrap">
                  {course.text}
                </Text>
              </Flex>
            </Card>
          </GridItem>
        ))}
      </Grid>

      <Grid gap="2" mt="2" templateColumns="repeat(5, 1fr)">
        {technologies.map((tech) => (
          <GridItem colSpan={1} key={tech.text}>
            <Card boxShadow="0px 0px 4px rgba(0, 0, 0, 0.24)" w="full">
              <Flex alignItems="center" gap="2" p="2">
                {tech.image && (
                  <Box h="6" position="relative" w="6">
                    <CmsImage data={tech.image.responsiveImage} />
                  </Box>
                )}
                <Text textStyle="lBold" whiteSpace="nowrap">
                  {tech.text}
                </Text>
              </Flex>
            </Card>
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};
